import BugsnagHelper from "./BugsnagHelper";
import CookieHelper from "./CookieHelper";

const bugsnagHelper = new BugsnagHelper();
const cookieHelper = new CookieHelper();

export { bugsnagHelper, cookieHelper };
